import ListProcesses from "@/views/organization/production/delivery_container/ListProcesses.vue";
import ListContainers from "@/views/organization/production/delivery_container/ListContainers.vue";
import ShowContainer from "@/views/organization/production/delivery_container/ShowContainer.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "production",
  permission: "delivery_container"
});

export default [
  {
    path: "/org/:organization_id/production/delivery_container/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/org/:organization_id/production/delivery_container/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/production/delivery_container/:agro_exporter_process_id/list_containers",
    name: routeName("list_containers"),
    component: ListContainers,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/production/delivery_container/:agro_exporter_process_id/show_container/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META
  }
]
